/**
 * Registro de temas: cada archivo src/themes/<id>.css es un tema. Se cargan
 * todos (webpack los inyecta) y el menú Tema los lista; agregar un tema es
 * solo agregar el archivo (ver la cabecera de oscuro.css).
 *
 * require.context solo existe en webpack: en jest (tests) no hay temas
 * cargados y la lista queda con el tema por defecto.
 *
 * OJO: llamar require.context(...) DIRECTO (webpack lo reemplaza al
 * compilar). Un `typeof require.context` webpack lo compila como un
 * contexto de TODA la carpeta (tests incluidos) cuyo .context es undefined:
 * no se cargaba ninguna hoja y los var(--wb-*) quedaban sin valor.
 */
// Tema para quien no ha elegido uno (menú ⋮ → Tema).
export const DEFAULT_THEME_ID = 'claro';
export const THEME_STORAGE_KEY = 'whisperbi.theme';

const loadThemeIds = () => {
  let context;
  try {
    context = require.context('./', false, /\.css$/);
  } catch (error) {
    return [DEFAULT_THEME_ID]; // jest: no hay require.context
  }
  context.keys().forEach((key) => context(key)); // inyecta cada hoja
  return context.keys().map((key) => key.replace(/^\.\//, '').replace(/\.css$/, ''));
};

// "alto-contraste" -> "Alto contraste"
export const themeLabel = (id) => {
  const words = id.replace(/[-_]+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const ids = loadThemeIds();
// El tema por defecto primero; el resto en orden alfabético.
export const THEMES = [DEFAULT_THEME_ID, ...ids.filter((id) => id !== DEFAULT_THEME_ID).sort()]
  .map((id) => ({ id, label: themeLabel(id) }));

export const isKnownTheme = (id) => THEMES.some((theme) => theme.id === id);
